// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './ProductTags.scss';

type Props = {
  tags: string[],
};

const ProductTags = ({ tags }: Props) => (
  <div className="ProductTags">
    {tags.map(t => (
      <Link to={`/search?q=&menu=products&facets=${encodeURIComponent(JSON.stringify({ tags: t }))}`} key={t}>
        #{t}
      </Link>
    ))}
  </div>
);

export default ProductTags;



// WEBPACK FOOTER //
// ./src/components/product/ProductTags/ProductTags.js